import { BrowserRouter } from "react-router";

interface IProps {
  children: React.ReactNode;
}

const RouterProvider = ({ children }: IProps) => {
  return <BrowserRouter>{children}</BrowserRouter>;
};

export default RouterProvider;
